import { render, staticRenderFns } from "./TheNavigation.vue?vue&type=template&id=c36b318c&"
import script from "./TheNavigation.vue?vue&type=script&lang=js&"
export * from "./TheNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TheNavigation.vue?vue&type=style&index=0&id=c36b318c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports